import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store";
import { _config } from "../common/js/constant"
import * as dd from "dingtalk-jsapi"; //钉钉
import login from '../views/login'; //登录
import home from '../views/home'; //首页
import myschedule from '../views/myschedule'; //待办
import customerList from '../views/customerList'; //客户列表
import customerAdd from '../views/customerAdd'; //创建客户
import customerDetail from '../views/customerDetail'; //客户详情
import customerTransfer from '../views/customerTransfer'; //客户转让
import customerFollow from '../views/customerFollow'; //客户添加跟进记录
import destineList from '../views/destineList'; //预订单
import destineAdd from '../views/destineAdd'; //预订单新增
import destineDetail from '../views/destineDetail'; //预订单详情
import roomList from '../views/roomList'; //房间列表
import roomDetail from '../views/roomDetail'; //房间详情
import contractList from '../views/contractList'; //合约列表
import contractDetail from '../views/contractDetail'; //合约详情
import contractAdd from '../views/contractAdd'; //合约创建
import approval from '../views/approval'; //查看审批
import orderList from '../views/orderList'; //账单列表
import returnOrderAdd from '../views/returnOrderAdd'; //退租中
import returnOrderDetail from '../views/returnOrderDetail'; //退租详情
import applyDetail from '../views/applyDetail'; //申请详情
import jointOrderAList from '../views/jointOrderAList'; //申请详情
import { getUser, getToken } from '@/utils/auth';
import { requestButtomAuth } from '@/api';

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'home',
        component: home,
        meta: {
            title: '首页'
        }
    },
    {
        path: '/login',
        name: 'login',
        component: login,
        meta: {
            title: '登录'
        }
    },
    {
        path: '/myschedule',
        name: 'myschedule',
        component: myschedule,
        meta: {
            title: '待办列表',
            keepAlive: true
        }
    },
    {
        path: '/customerList',
        name: 'customerList',
        component: customerList,
        meta: {
            title: '客户列表',
            keepAlive: true
        }
    },
    {
        path: '/customerAdd',
        name: 'customerAdd',
        component: customerAdd,
        meta: {
            title: '创建客户'
        }
    },
    {
        path: '/customerDetail',
        name: 'customerDetail',
        component: customerDetail,
        meta: {
            title: '客户详情'
        }
    },
    {
        path: '/customerTransfer',
        name: 'customerTransfer',
        component: customerTransfer,
        meta: {
            title: '转让'
        }
    },
    {
        path: '/customerFollow',
        name: 'customerFollow',
        component: customerFollow,
        meta: {
            title: '添加跟进记录'
        }
    },
    {
        path: '/destineList',
        name: 'destineList',
        component: destineList,
        meta: {
            title: '预订单',
            keepAlive: true
        }
    },
    {
        path: '/destineAdd',
        name: 'destineAdd',
        component: destineAdd,
        meta: {
            title: '预订单新增'
        }
    },
    {
        path: '/destineDetail',
        name: 'destineDetail',
        component: destineDetail,
        meta: {
            title: '预订单详情'
        }
    },
    {
        path: '/contractList',
        name: 'contractList',
        component: contractList,
        meta: {
            title: '合约列表',
            keepAlive: true
        }
    },
    {
        path: '/contractDetail',
        name: 'contractDetail',
        component: contractDetail,
        meta: {
            title: '合约详情'
        }
    },
    {
        path: '/contractAdd',
        name: 'contractAdd',
        component: contractAdd,
        meta: {
            title: '合约编辑'
        }
    },
    {
        path: '/roomList',
        name: 'roomList',
        component: roomList,
        meta: {
            title: '房间列表',
            keepAlive: true
        }
    },
    {
        path: '/roomDetail',
        name: 'roomDetail',
        component: roomDetail,
        meta: {
            title: '房间详情'
        }
    },
    {
        path: '/approval',
        name: 'approval',
        component: approval,
        meta: {
            title: '审批'
        }
    },
    {
        path: '/orderList',
        name: 'orderList',
        component: orderList,
        meta: {
            title: '账单列表',
            keepAlive: true
        }
    },
    {
        path: '/returnOrderAdd',
        name: 'returnOrderAdd',
        component: returnOrderAdd,
        meta: {
            title: '退租中'
        }
    },
    {
        path: '/returnOrderDetail',
        name: 'returnOrderDetail',
        component: returnOrderDetail,
        meta: {
            title: '退租详情'
        }
    },
    {
        path: '/applyDetail',
        name: 'applyDetail',
        component: applyDetail,
        meta: {
            title: '申请详情'
        }
    },
    {
        path: '/fssContractList',
        name: 'fssContractList',
        component: () =>
            import (`@/views/fssContractList`),
        meta: {
            title: '分散式收房合约',
            keepAlive: true
        }
    },
    {
        path: '/fssContractAdd',
        name: 'fssContractAdd',
        component: () =>
            import (`@/views/fssContractAdd`),
        meta: {
            title: '收房合约创建'
        }
    },
    {
        path: '/fssContractDetail',
        name: 'fssContractDetail',
        component: () =>
            import (`@/views/fssContractDetail`),
        meta: {
            title: '收房详情'
        }
    },
    {
        path: '/jzsContractDetail',
        name: 'jzsContractDetail',
        component: () =>
            import (`@/views/jzsContractDetail`),
        meta: {
            title: '收房详情'
        }
    },
    {
        path: '/fssReturnDetail',
        name: 'fssReturnDetail',
        component: () =>
            import (`@/views/fssReturnDetail`),
        meta: {
            title: '退房详情'
        }
    },
    {
        path: '/jzsReturnDetail',
        name: 'jzsReturnDetail',
        component: () =>
            import (`@/views/jzsReturnDetail`),
        meta: {
            title: '退房详情'
        }
    },
    {
        path: '/communityDetail',
        name: 'communityDetail',
        component: () =>
            import (`@/views/communityDetail`),
        meta: {
            title: '小区详情'
        }
    },
    {
        path: '/remodelDetail',
        name: 'remodelDetail',
        component: () =>
            import (`@/views/remodelDetail`),
        meta: {
            title: '装修单详情'
        }
    },
    {
        path: '/workOrderList',
        name: 'workOrderList',
        component: () =>
            import (`@/views/workOrderList`),
        meta: {
            title: '工单列表',
            keepAlive: true
        }
    },
    {
        path: '/workOrderAdd',
        name: 'workOrderAdd',
        component: () =>
            import (`@/views/workOrderAdd`),
        meta: {
            title: '工单创建'
        }
    },
    {
        path: '/workOrderDetail',
        name: 'workOrderDetail',
        component: () =>
            import (`@/views/workOrderDetail`),
        meta: {
            title: '工单详情'
        }
    },
    {
        path: '/propertyList',
        name: 'propertyList',
        component: () =>
            import (`@/views/propertyList`),
        meta: {
            title: '业主列表',
            keepAlive: true
        }
    },
    {
        path: '/propertyAdd',
        name: 'propertyAdd',
        component: () =>
            import (`@/views/propertyAdd`),
        meta: {
            title: '创建业主'
        }
    },
    {
        path: '/propertyDetail',
        name: 'propertyDetail',
        component: () =>
            import (`@/views/propertyDetail`),
        meta: {
            title: '业主详情'
        }
    },
    {
        path: '/reportList',
        name: 'reportList',
        component: () =>
            import (`@/views/reportList`),
        meta: {
            title: '汇总统计'
        }
    },
    {
        path: '/jointOrderAList',
        name: 'jointOrderAList',
        component: () =>
            import (`@/views/jointOrderAList`),
        meta: {
            title: 'A联单',
            keepAlive: true
        }
    },
    {
        path: '/jointOrderAAdd',
        name: 'jointOrderAAdd',
        component: () =>
            import (`@/views/jointOrderAAdd`),
        meta: {
            title: '新增',
            keepAlive: true
        }
    },
    {
        path: '/jointOrderAFollow',
        name: 'jointOrderAFollow',
        component: () =>
            import (`@/views/jointOrderAFollow`),
        meta: {
            title: '添加跟进记录',

        }
    },
    {
        path: '/jointOrderADetail',
        name: 'jointOrderADetail',
        component: () =>
            import (`@/views/jointOrderADetail`),
        meta: {
            title: '客户详情',
        }
    },
    {
        path: '/jointOrderATransfer',
        name: 'jointOrderATransfer',
        component: () =>
            import (`@/views/jointOrderATransfer`),
        meta: {
            title: '转让',
        }
    },
    {
        path: '/jointOrderAExplore',
        name: 'jointOrderAExplore',
        component: () =>
            import (`@/views/jointOrderAExplore`),
        meta: {
            title: '实勘',
        }
    },
    {
        path: '/jointOrderConstruct',
        name: 'jointOrderConstruct',
        component: () =>
            import (`@/views/jointOrderConstruct`),
        meta: {
            title: '施工宝'
        }
    },
    {
        path: '/deviceDetail',
        name: 'deviceDetail',
        component: () =>
            import (`@/views/deviceDetail`),
        meta: {
            title: '设备详情'
        }
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
router.beforeEach(async(to, from, next) => {
    // next()
    //缓存
    if (to.meta.keepAlive && store.state.keepAlive.indexOf(to.name) == -1) {
        console.log([...store.state.keepAlive, ...[to.name]])
        store.commit('SET_KEEP_ALIVE', [...store.state.keepAlive, ...[to.name]])
    }
    if (to.name == 'home') {
        store.commit('SET_KEEP_ALIVE', [])
    }
    if (to.name !== 'myschedule') {
        if (dd.env.platform !== "notInDingTalk") {
            dd.ready(function() {
                dd.biz.navigation.setTitle({
                    title: to.meta.title || 'CRM',
                    onSuccess: function(result) {},
                    onFail: function(err) {}
                })
            })
        }
        document.title = to.meta.title || 'CRM'
    }
    // const hasUser = getUser()
    // if (hasUser) {
    //     if (to.path === '/login') {
    //         next('/')
    //     } else {
    //         next()
    //     }
    // } else {
    //     if (to.path === '/login') {
    //         next()
    //     } else {
    //         next('/login')
    //     }
    // }
    // if (store.state.buttonAuth.length == 0) {
    //     requestButtomAuth().then(res => {
    //         store.commit('SET_BUTTON', res.data || [])
    //     })
    // }
    const hasToken = getToken()
    if (store.state.token) {
        if (store.state.buttonAuth.length == 0) {
            requestButtomAuth().then(res => {
                store.commit('SET_BUTTON', res.data || [])
            })
        }
        next()
    } else {
        if (to.path === '/login') {
            next()
        } else {
            store.dispatch('getPhone').then(res => {
                next()
            }).catch(err => {
                next(false)
            })
        }
    }
})
export default router